import { adminPath } from '@/core/utils/env.utils';

export const DOCUMENT_ENDPOINTS = {
  LIST: adminPath('/pdfs'),
  CREATE: adminPath('/pdfs'),
  DOWNLOAD_FILE: (pdfId: string) => adminPath(`/pdfs/${pdfId}/file`),
  DELETE: (pdfId: string) => adminPath(`/pdfs/${pdfId}`),
} as const;
